module.exports = __webpack_public_path__ + "static/img/liu5.2bbf2d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/img/liu5.png
// module id = X91B
// module chunks = 3